import { AuthService } from './../../services/auth.service';
import { Component, OnInit, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { ViewEncapsulation } from '@angular/core';
import { AsidebarComponent } from '../asidebar/asidebar.component';
import { ToastrService } from 'ngx-toastr';

declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
@NgModule({
  declarations: [AsidebarComponent],
})
export class DashboardComponent implements OnInit {
  user: Object;
  loading: Boolean = false;

  constructor(
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.user = this.auth.user;
  }

  toggleMenu() {
    $('#sidebar').toggleClass('active');
    $('#rotateN').toggleClass('rotate180');
    $('#sidebarCollapse').toggleClass('m10Sty');
    let elem = document.getElementById('asdsadada');
    if (elem.classList.contains('disnone')) {
      setTimeout(() => {
        $('#asdsadada').toggleClass('disnone');
      }, 200);
    } else {
      $('#asdsadada').toggleClass('disnone');
    }
    // $('#asdsadada').toggleClass('disnone');
  }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }
}
